const makeConstant = constant => `billing/${constant}`

export const SET_PLAN = makeConstant('SET_PLAN')
export const SET_COUPON = makeConstant('SET_COUPON')
export const SET_USE_NETSUITE = makeConstant('SET_USE_NETSUITE')

export const FETCH_DEAL = makeConstant('FETCH_DEAL')
export const FETCH_DEAL_SUCCESS = makeConstant('FETCH_DEAL_SUCCESS')
export const FETCH_DEAL_PENDING = makeConstant('FETCH_DEAL_PENDING')
export const FETCH_DEAL_FAILED = makeConstant('FETCH_DEAL_FAILED')
export const SKIP_REDIRECT_AFTER_RECURLY_DEAL_ACTIVATION = makeConstant('SKIP_REDIRECT_AFTER_RECURLY_DEAL_ACTIVATION')

export const ACTIVATE_DEAL = makeConstant('ACTIVATE_DEAL')
export const ACTIVATE_DEAL_SUCCESS = makeConstant('ACTIVATE_DEAL_SUCCESS')
export const ACTIVATE_DEAL_PENDING = makeConstant('ACTIVATE_DEAL_PENDING')
export const ACTIVATE_DEAL_FAILED = makeConstant('ACTIVATE_DEAL_FAILED')
